export default {
    SET_INSTITUTIONS_TOTAL(state, institutionsTotal) {
        state.institutionsTotal = institutionsTotal;
    },

    SET_LOADING(state, payload) {
        state.loading = payload;
    },

    SET_TOKEN(state, token) {
        state.token = token;
    }
};
